import { inject, PLATFORM_ID } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ProductService } from "src/app/services/product.service";
import { Book } from "src/app/models/shared-models/book.model";
import { isPlatformServer } from "@angular/common";

export const bookResolver: ResolveFn<Book | null> = async (route) => {
  const productService = inject(ProductService);
  const platformId = inject(PLATFORM_ID);
  const isbn = route.paramMap.get("isbn");

  // Inject response on server-side for status code setting
  let serverResponse: any = null;
  if (isPlatformServer(platformId)) {
    try {
      serverResponse = inject("RESPONSE" as any);
    } catch (e) {
      console.warn("Could not inject server response:", e);
    }
  }

  if (!isbn) {
    return null;
  }

  try {
    const response = await productService.getBook(isbn);
    const error = response as any;
    if (error["statusCode"] === 404) {
      // set 404 status code on server-side
      if (serverResponse && typeof serverResponse.status === "function") {
        serverResponse.status(404);
      }
      return null;
    }
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
};
